import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const CustomCard = makeShortcode("CustomCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "key-features-of-adobe-document-generation-api"
    }}>{`Key features of Adobe Document Generation API`}</h2>
    <CustomCard slots="icon,heading,text,buttons" gradients gradientsType='lightBlue' buttonDisplay borderRadious cursorDisable variantsTypePrimary="staticWhite" variantStyleFill='fill' width="25%" theme="light" className='bgcolor' mdxType="CustomCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/80c8b9ed627dc6dd6f3d6925de174cb3/ic-msword.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "rapid-template-tagging-from-uploaded-json-data"
    }}>{`Rapid template tagging from uploaded JSON data`}</h3>
    <p>{`Automatically generate tags from your JSON data model or create reusable tags using our Document Generation Tagger Microsoft Word add-in. Preview your document by generating it within Word.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/document-generation-api/wordaddin/"
        }}>{`Get Microsoft Word add-in`}</a></li>
    </ul>
    <CustomCard slots="icon,heading,text" gradients gradientsType='orangeRed' borderRadious cursorDisable width="25%" theme="light" mdxType="CustomCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/41c0a913641b430ea1fd754e2ad57a30/ic-insert.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "insert-elements-during-document-generation"
    }}>{`Insert elements during document generation`}</h3>
    <p>{`Dynamically insert tags, images, lists, and generate tables based on data inputs and conditions for granular content customization.`}</p>
    <CustomCard slots="icon,heading,text" gradients gradientsType='violetBlue' borderRadious cursorDisable width="25%" theme="light" mdxType="CustomCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d56f277e357d7b09ac3c8fea9548d0f0/ic-sign.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "out-of-the-box-integration-with-adobe-acrobat-sign"
    }}>{`Out of the box integration with Adobe Acrobat Sign`}</h3>
    <p>{`Accelerated text tag creation with the ability to conditionally show and hide signatures or content, mark fields as required, read only, and generate documents that are ready for processing in Adobe Acrobat Sign.`}</p>
    <CustomCard slots="icon,heading,text" gradients gradientsType='pinkRed' borderRadious cursorDisable width="25%" theme="light" mdxType="CustomCard" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/bbf4b3e263f489586dea06f4746a1d81/ic-cloud-rest-api.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "cloud-based-rest-api-integrates-with-any-application"
    }}>{`Cloud-based REST API integrates with any application`}</h3>
    <p>{`Embed document generation into any application in minutes with our SDKs for Node.js, .Net, and Java. Postman collection provides a QuickStart for API calls.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      